import StickySidebar from "sticky-sidebar";

export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.frontFixedButtons();
    this.loginSlidebar();
    this.spAccordion();
    this.eventSearch();
    this.entryLabel();
    this.spSearchForm();
  }

  /**
   * カスタム関数
   */

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }


  frontFixedButtons() {
    let $target = $('.js-floating-buttons');

    if ($target.length <= 0) {
      return false;
    }

    let $offer = $('.l-offer');
    let $offerPostion = $offer.offset().top;
    let $offerheight = $offer.height();

    console.log($offerPostion);
    $(window).scroll(function () {
      $target.each(function () {
        var scroll = $(window).scrollTop();

        if (scroll > $offerPostion - $offerheight) {
          $(this).addClass('is-fadeout');
        } else {
          $(this).removeClass('is-fadeout');
        }
      });
    });
  }

  loginSlidebar() {
    let $target = $('.js-slidebar-login');
    if ($target.length <= 0) {
      return false;
    }
    if (window.innerWidth < 420) {
      return false
    }
    let sidebar = document.querySelector('.c-slidebar-login');
    var _sidebar = new StickySidebar('.c-slidebar-login', {
      topSpacing: 104,
      bottomSpacing: 0,
      containerSelector: '.l-main.is-login',
      innerWrapperSelector: '.c-slidebar-login__list',
      resizeSensor: true,
    });

    const resizeObserver = new ResizeObserver((entries) => {
      _sidebar.updateSticky()
      let height = document.querySelector('.c-slidebar-login__list').getBoundingClientRect().height
      // document.querySelector(".l-main-wrapper").style.minHeight = height + "px"
    });
    resizeObserver.observe(document.querySelector('.c-slidebar-login__list'));
    // let $position = 0;
    // let $menuList = "";
    // let $menuItem = "";
    // let $footerHeight = "";
    // let $windowPageHeight = "";
    // let $windowHeight = "";
    // let $header = "";
    // let $headerHeight = "";
    // let $openScroll = 0;
    // let $menuListHeight;

    // $(window).on('load', function () {
    //   $menuList = $target.find('.c-slidebar-login__list');
    //   $menuItem = $menuList.find('.c-slidebar-login__item');
    //   $footerHeight = $('.l-footer').height();
    //   $windowPageHeight = $(document).innerHeight();
    //   $windowHeight = $(window).innerHeight();
    //   $header = $('.l-header');
    //   $headerHeight = $header.height();

    //   // クリック時の処理
    //   $menuItem.on('click', function () {
    //     $target.toggleClass('is-active');
    //     $menuList.css('top', '0px');
    //     $openScroll = $(window).scrollTop();

    //     setTimeout(function () {
    //       $menuListHeight = $menuList.height() + $headerHeight;
    //       if ($openScroll + $menuListHeight + 1 >= $('body').height()) {
    //         $menuList.css('top', - ($menuListHeight - $windowHeight + $footerHeight + $headerHeight) + 'px');
    //       }
    //     }, 305);
    //   })
    // })

    // $(window).on('scroll', function () {
    //   var scroll = $(window).scrollTop();
    //   $menuListHeight = $menuList.height() + $headerHeight;

    //   if ($menuListHeight > $windowHeight) {
    //     let $heightDifference = $menuListHeight - $windowHeight + 300; // 差分数値
    //     if (scroll >= 1) {

    //       if ($openScroll + $heightDifference >= scroll) {
    //         if ($target.hasClass('is-scroll-Va')) {
    //           $menuList.css('top', - scroll + $openScroll + 'px');
    //           $target.removeClass('is-scroll-Va');
    //         } else {
    //           $menuList.css('top', - scroll + $openScroll + 'px');
    //         }
    //       }

    //       // 上スクロール監視
    //       if ($position > $(window).scrollTop()) {
    //         if ($openScroll - scroll > 0) {
    //           $menuList.css('top', '0px');
    //           $target.addClass('is-scroll-Va');
    //           $openScroll = $(window).scrollTop();
    //         }
    //       }
    //     } else {
    //       if ($heightDifference >= scroll) {
    //         $menuList.css('top', - scroll + 'px');
    //       }
    //     }
    //   }
    //   $position = $(window).scrollTop();
    // });

  }


  spAccordion() {
    let $target = $('.js-sp-accordion');
    if ($target.length <= 0) {
      return false;
    }

    let $window = window.innerWidth;
    if ($window < 950) {
      $target.addClass('js-accordion')
    }
  }

  eventSearch() {
    let $container = $('.js-selectors-container');
    if ($container.length <= 0) {
      return false;
    }

    let $firstBlock = $('.js-first-choise');
    let $lastBlock = $('.js-last-choise');

    let $firstSlecter = $firstBlock.find('select');
    let $secondSlecter = $lastBlock.find('select');


    $firstSlecter.change(function () {
      $lastBlock.removeClass('is-hidden');
      $lastBlock.find('.is-hide option').unwrap();

      let val = $(this).val();
      $lastBlock.find('option').prop('disabled', true).wrap('<span class="is-hide">');
      $lastBlock.find('option').eq(0).unwrap().prop('disabled', false);
      $lastBlock.find('option[data-key="' + val + '"]').unwrap().prop('disabled', false);
      $lastBlock.find('option').eq(0).prop('selected', true);
    });

    $secondSlecter.change(function () {
      let val = $(this).val();

      $('.js-child-id').val(val);
    });

    // add wp
    let url = new URL(window.location.href); // URLを取得
    let params = url.searchParams; // URLSearchParamsオブジェクトを取得
    if (params.has('s_product_category[]')) {
      $lastBlock.removeClass('is-hidden');

      let val = params.get('s_product_category[]');

      // $lastBlock.find('option').prop('disabled', true).unwrap();
      $lastBlock.find('.is-hide option').unwrap();
      $lastBlock.find('option').prop('disabled', true).wrap('<span class="is-hide">');
      $lastBlock.find('option[data-key="' + val + '"]').unwrap().prop('disabled', false);

      if (params.has('child_id')) {
        let child_id = params.get('child_id');
        $lastBlock.find('option[value="' + child_id + '"]').prop('disabled', false).prop('selected', true);
        if (!child_id) {
          $lastBlock.find('option').eq(0).unwrap().prop('disabled', true).prop('selected', true);
        }
      } else {
        $lastBlock.find('option').eq(0).unwrap().prop('disabled', true).prop('selected', true);
      }
    }
  }

  spSearchForm() {
    let $target = $('.l-header__sp-search');
    if ($target.length <= 0) {
      return false;
    }
    let $targetButton = $target.find('.l-header__sp-search-icon');
    $targetButton.on('click', function () {
      $(this).toggleClass('is-active');
    })
  }

  entryLabel() {
    let $target = $('.c-block-entry-form__label-input');
    if ($target.length <= 0) {
      return false;
    }
    $target.on('change', function () {
      $target.parent('label').toggleClass('is-acitve')
    })
  }

  // 複製して作業
  mycode() {

  }


}




